import React from "react";

export const About = (props) => {
  return (
    <div id="about" style={{ position: "relative", overflow: "hidden" }}>
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
        }}
      >
        <source src="/img/aboutBG2.mp4" type="video/mp4" />
        Tu navegador no soporta videos.
      </video>

      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img src="img/watchs.png" className="img-responsive" alt="" />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>{props.data ? props.data.title : "loading..."}</h2>
              <p style={{ fontSize: "22px" }}>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3 style={{ fontSize: "25px" }}>{props.data ? props.data.why_c : "loading..."}</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li style={{ fontSize: "20px" }} key={`${d}-${i}`}>
                            {d}
                          </li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li style={{ fontSize: "20px" }} key={`${d}-${i}`}>
                            {d}
                          </li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
              <div
                className="col-lg-12 col-sm-12 col-xs-12"
                style={{ display: "flex" }}
              >
                <button
                  onClick={() => props.onNavigate("product")}
                  className="btn-custom"
                  style={{ margin: "auto", marginTop: "50px" }}
                >
                  {props.data ? props.data.ButtonBuy : "loading..."}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
